import React from 'react';

interface Props {
  className?: string;
}

export const IconArrow: React.FC<Props> = ({ className }) => {
  return (
    <svg
      className={className}
      width="18"
      height="9"
      viewBox="0 0 18 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.92 0.949951L10.4 7.46995C9.62996 8.23995 8.36996 8.23995 7.59996 7.46995L1.07996 0.949951"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
